<script setup lang="ts">
interface Item {
	content: string
}

interface Section {
	name: string
	items: Item[]
}

const changelogSections: Section[] = [
	{
		name: '27 February 2025',
		items: [
			{
				content: 'Beta version of the platform is released.',
			},
		],
	},
]
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper class="flex flex-col gap-8">
		<template v-for="section in changelogSections" :key="section.name">
			<div>
				<h2 class="text-primary mb-4 rounded border-b py-2 text-2xl font-bold">
					{{ section.name }}
				</h2>

				<ul class="text-muted-foreground max-w-3xl list-inside list-disc">
					<li v-for="item in section.items" :key="item.content">
						{{ item.content }}
					</li>
				</ul>
			</div>
		</template>
	</content-wrapper>
</template>
